import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import { Option } from './Option';

// Analytic Event Action Subjects:
export const OPTION_SELECT_ACTION_SUBJECT = 'selectDropdown';
export const SOURCE_SPACE_SELECT_ACTION_SUBJECT = 'spaceSelect';
export const BUTTON_ACTION_SUBJECT = 'button';

// Analytic Event Action Subject IDs for the CSP Option Select control:
export const OPTION_SELECT_DROPDOWN_OPEN_ACTION_SUBJECT_ID =
	'copySpacePermissionsSpacePermissionsDropdownOpen';
export const OPTION_SELECT_COPY_EXISTING_ACTION_SUBJECT_ID = 'copySpacePermissionsCopyFromExisting';
export const OPTION_SELECT_DEFAULT_ACTION_SUBJECT_ID = 'copySpacePermissionsUseDefaults';
export const OPTION_SELECT_PRIVATE_ACTION_SUBJECT_ID = 'copySpacePermissionsMakePrivate';

// Translates an option selected from the CSP Option Select control into Action Subject ID:
const OptionToEventActionSubjectIdMap = new Map<Option, string>([
	[Option.ONLY_VISIBLE_TO_ME, OPTION_SELECT_PRIVATE_ACTION_SUBJECT_ID],
	[Option.DEFAULT_PERMISSIONS, OPTION_SELECT_DEFAULT_ACTION_SUBJECT_ID],
	[Option.COPY_PERMISSIONS_FROM_ANOTHER_SPACE, OPTION_SELECT_COPY_EXISTING_ACTION_SUBJECT_ID],
]);

// Function that takes a a CSP Option and returns the associate Action Subject ID
export const getEventActionSubjectId = (option: Option): string =>
	OptionToEventActionSubjectIdMap.get(option) || '';

// Analytic Event Action Subject IDs for selecting a Source Space for Copy Existing Perms
export const SOURCE_SPACE_SELECTED_SUBJECT_ID = 'copySpacePermissionsSourceSpaceSelected';

// Analytic Event Action Subject IDs for the Copy Existing Perms "Apply" button and confirmation dialog:
export const APPLY_PERMS_ACTION_SUBJECT_ID = 'copySpacePermissionsApplyPermissions';
export const RESTORE_DEFAULT_PERMS_ACTION_SUBJECT_ID = 'spacePermissionsRestoreDefaults';
export const APPLY_PERMS_CANCEL_ACTION_SUBJECT_ID = 'copySpacePermissionsCancelApply';
export const APPLY_PERMS_CONFIRM_ACTION_SUBJECT_ID = 'copySpacePermissionsConfirmApply';

// Fires an analytics UI Click Event
export const fireUIClickEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	actionSubject: string,
	actionSubjectId: string,
) => {
	createAnalyticsEvent({
		type: 'sendUIEvent',
		data: {
			action: 'clicked',
			actionSubject,
			actionSubjectId,
		},
	}).fire();
};
